<template>
  <div class="ElasticComputeCloudDetail">
    <div class="ElasticComputeCloudDetail-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticComputeCloudMonitor">{{
          $t("alarms.instance.instance")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Row type="flex" justify="space-between" class="code-row-bg">
      <Col span="6">
        <Card style="height: 480px">
          <Row>
            <Row style="height: 200px">
              <Col
                span="24"
                style="
                  text-align: center;
                  font-size: 103px;
                  display: block;
                  margin-top: 8px;
                "
              >
                <Icon type="ios-desktop-outline" />
              </Col>
              <Col style="text-align: center; font-size: 18px">{{
                this.$route.query.name
              }}</Col>
            </Row>

            <Row style="margin-bottom: 20px">
              <Col>{{ $t("alarms.common.hostDescription") }}</Col>
              <Col>---</Col>
            </Row>
            <Row>
              <Col style="margin-bottom: 8px">{{
                $t("alarms.instance.instanceConfiguration")
              }}</Col>
              <Row :gutter="16">
                <Col span="10">{{ $t("alarms.instance.accountType") }}:</Col>
                <Col span="12">{{ this.$route.query.accountTypeName }}</Col>
              </Row>
              <!-- AWS -->
              <Row v-show="isAWS" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.instance") }}:</Col>
                <Col span="12">{{ cpuCoreNumber }}</Col>
              </Row>
              <Row v-show="isAWS" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.disk") }}:</Col>
                <Col span="12"
                  >{{ $t("alarms.instance.total") }} {{ numberOfDisk }}
                  {{ $t("alarms.instance.diskSize") }}</Col
                >
              </Row>
              <Row v-show="isAWS" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.systemDisk") }}:</Col>
                <Col span="12"
                  >{{ systemVolumeName }},{{ systemVolumeSize }}G</Col
                >
              </Row>
              <Row v-show="isAWS" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.dateDisk") }}:</Col>
                <Col span="12">
                  <Row
                    v-for="(item, index) in dataVolumeList"
                    v-bind:key="index"
                  >
                    <Col span="5"></Col>
                    <Col>{{ item.key }},{{ item.value }}G</Col>
                  </Row>
                </Col>
              </Row>
              <!-- Azure -->
              <Row v-show="isAzure" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.disk") }}:</Col>
                <Col span="12">{{ $t("monitor.ec2.detail.totalDisks", { n: numberOfDisk }) }}</Col>
              </Row>
              <Row v-show="isAzure" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.systemDisk") }}:</Col>
                <Col span="12" style="word-wrap: break-word">{{
                  systemVolumeName
                }}</Col>
              </Row>
              <Row v-show="isAzure" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.dateDisk") }}:</Col>
                <Col span="12">
                  <Row
                    v-for="(item, index) in dataVolumeList"
                    v-bind:key="index"
                  >
                    <Col span="5"></Col>
                    <Col>{{ item.key }}</Col>
                  </Row>
                </Col>
              </Row>
              <!-- VMware -->
              <Row v-show="isVMware" :gutter="16">
                <Col span="10">{{ $t("monitor.ec2.detail.cpuCoreCount") }}:</Col>
                <Col span="12">{{ $t("monitor.ec2.detail.coresValue", { n: cpuCoreNumber }) }}</Col>
              </Row>
              <Row v-show="isVMware" :gutter="16">
                <Col span="10">{{ $t("monitor.ec2.detail.totalMemorySize") }}:</Col>
                <Col span="12" style="word-wrap: break-word"
                  >{{ totalMemory }} GB</Col
                >
              </Row>
              <Row v-show="isVMware" :gutter="16">
                <Col span="10">{{ $t("monitor.ec2.detail.totalDiskSize") }}:</Col>
                <Col span="12" style="word-wrap: break-word"
                  >{{ totalDiskSize }} GB</Col
                >
              </Row>
              <!-- GCP -->
              <Row v-show="isGCP" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.instance") }}:</Col>
                <Col span="12">{{ cpuCoreNumber }}</Col>
              </Row>
              <Row v-show="isGCP" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.disk") }}:</Col>
                <Col span="12"
                  >{{ $t("alarms.instance.total") }} {{ numberOfDisk }}
                  {{ $t("alarms.instance.diskSize") }}</Col
                >
              </Row>
              <!-- Aliyun -->
              <Row v-show="isALY" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.instance") }}:</Col>
                <Col span="12">{{ cpuCoreNumber }}</Col>
              </Row>
              <!-- Tencent Cloud -->
              <Row v-show="isTencent" :gutter="16">
                <Col span="10">{{ $t("alarms.instance.instance") }}:</Col>
                <Col span="12">{{ cpuCoreNumber }}</Col>
              </Row>
              <!-- <Row v-show="isAWS" :gutter="16">
                                <Col span="10">{{ $t('alarms.instance.systemDisk') }}:</Col>
                                <Col span="12">{{systemVolumeName}},{{systemVolumeSize}}G</Col>
                            </Row> -->
              <!-- <Row v-show="isAWS" :gutter="16">
                                <Col span="10">{{ $t('alarms.instance.dateDisk') }}:</Col>
                                <Col span="12">
                                    <Row v-for="(item,index) in dataVolumeList" v-bind:key="index">
                                        <Col span="5"></Col>
                                        <Col>{{item.key}},{{item.value}}G</Col>
                                    </Row>

                                </Col>
                            </Row> -->
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="13">
        <Card style="height: 480px">
          <ul class="content">
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-laptop"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.instance.hostInformation") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.instance.instanceId") }}：</li>
                            <li>{{ instanceId }}</li>
                          </ul>
                        </Col>
                        <!-- AWS -->
                        <Col v-show="isAWS">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ launchTime }}</li>
                          </ul>
                        </Col>
                        <!-- 阿里云 -->
                        <Col v-show="isALY">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ startTime }}</li>
                          </ul>
                        </Col>
                        <!-- GCP -->
                        <Col v-show="isGCP">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ launchTime }}</li>
                          </ul>
                        </Col>
                        <!-- Tencent Cloud -->
                        <Col v-show="isTencent">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ launchTime }}</li>
                          </ul>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-pulse"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.monitorMessage") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.monitorItems") }}：</li>
                            <li>
                              {{ monitoringNum }}{{ $t("alarms.common.count") }}
                            </li>
                          </ul>
                        </Col>
                        <Col>
                          <a @click="monitorEC" v-hasPermission="['monitor:elasticComputeCloudDetail:overview']">{{
                            $t("alarms.common.viewMonitoringOverview")
                          }}</a>
                        </Col>
                        <Col v-if="this.$route.query.accountTypeName == 'AWS'">
                          <a @click="handleViewForecastMonitoringOverview">{{
                            $t("alarms.common.viewForecastMonitoringOverview")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-medkit-outline"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.alertRule") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.alertRule") }}：</li>
                            <li>{{ priorityNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.untreated") }}：</li>
                            <li>{{ statusNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <a @click="alertRule" v-hasPermission="['monitor:elasticComputeCloudDetail:alert_rule']">{{
                            $t("alarms.common.viewAlarmRules")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
          </ul>
        </Card>
      </Col>
      <Col span="4">
        <Card style="min-height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <!-- AWS -->
            <Row v-show="isAWS">
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
            <!-- 阿里云 -->
            <Row v-show="isALY">
              <Col v-for="(item, index) in ecstagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
            <!-- Azure -->
            <Row v-show="isAzure">
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
            <!-- GCP -->
            <Row v-show="isGCP">
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
            <!-- Tencent Cloud -->
            <Row v-show="isTencent">
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import utils from "../../../utils/utils.js";
export default {
  name: "ElasticComputeCloudDetail",
  data() {
    return {
      isAWS: false,
      isALY: false,
      isAzure: false,
      isVMware: false,
      isGCP: false,
      isTencent: false,
      id: "",
      accountId: "",
      instanceId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      cpuCoreNumber: "",
      privateIpAddress: "",
      rootDeviceType: "",
      numberOfDisk: "",
      launchTime: "",
      priorityNum: "",
      statusNum: "",
      monitoringNum: "",
      privateIp: "",
      tagList: [],
      ecstagList: [],
      systemVolumeName: "",
      systemVolumeSize: "",
      startTime: "",
      dataVolumeList: [],
      cpuCoreNumber: "",
      totalDiskSize: "",
      totalMemory: ""
    };
  },
  mounted() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryInstancesByInstanceId();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryInstancesByInstanceId();
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.queryInstancesByInstanceId();
    } else if (this.$route.query.accountTypeName == "VMware") {
      this.isVMware = true;
      this.queryInstancesByInstanceId();
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryInstancesByInstanceId();
    } else if (this.$route.query.accountTypeName == "Tencent Cloud") {
      this.isTencent = true;
      this.queryInstancesByInstanceId();
    }
  },
  methods: {
    init: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.instanceId = this.$route.query.instanceId;
      this.region = this.$route.query.region;
      this.privateIp = this.$route.query.privateIp;
      this.accountName = this.$route.query.accountName;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.name = this.$route.query.name;
    },
    // 通过instanceId查询实例
    queryInstancesByInstanceId: function() {
      this.$api.instance
        .queryInstancesByInstanceId({
          accountId: this.$route.query.accountId,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region
        })
        .then(res => {
          this.cpuCoreNumber = res.data.cpuCoreNumber;
          this.privateIpAddress = res.data.privateIpAddress;
          this.rootDeviceType = res.data.rootDeviceType;
          this.numberOfDisk = res.data.numberOfDisk;
          this.instanceId = res.data.instanceId;
          this.launchTime = utils.methods.formatDate(res.data.launchTime);
          this.startTime = utils.methods.formatDate(res.data.startTime);
          this.priorityNum = res.data.priorityNum;
          this.statusNum = res.data.statusNum;
          this.monitoringNum = res.data.monitoringNum;
          this.tagList = res.data.tags;
          this.ecstagList = res.data.ecstag;
          this.systemVolumeName = res.data.systemVolumeName;
          this.systemVolumeSize = res.data.systemVolumeSize;
          this.dataVolumeList = res.data.dataVolume;
          this.cpuCoreNumber = res.data.cpuCoreNumber;
          this.totalDiskSize = res.data.totalDiskSize;
          this.totalMemory = res.data.totalMemory;
        });
    },
    // 点击查看监控概览
    monitorEC: function() {
      this.init();
      this.$router.push({
        path: "/monitor/instance/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    },
    // 点击查看报警规则
    alertRule: function() {
      this.init();
      this.$router.push({
        path: "/monitor/elasticComputeCloudWarning/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    },
    // 查看预测监控概况
    handleViewForecastMonitoringOverview() {
      this.init();
      this.$router.push({
        path: "/monitor/instanceForecast/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          // privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    }
  }
};
</script>

<style scoped>
.ElasticComputeCloudDetail-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.host ul {
  list-style: none;
  overflow: hidden;
}
.host ul li {
  float: left;
}
.content > li {
  margin-bottom: 6px;
  border-bottom: 1px dashed #ccc;
  padding: 12px;
}
.content > li:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ec2/ElasticComputeCloudDetail.vue